import { useTranslation } from 'react-i18next';
import Field from '../ui/Field';
import type { WarrantyValue } from './projectModel';

/**
 * D-303 / D-304 — "אחריות ללקוח": the date OTE is committed to the customer until, or "אין אחריות".
 * Used in the project / development form and in the small window that opens when a project / development
 * is moved to "הסתיים" (where one of the two is required).
 */
export default function WarrantyField({ id, value, onChange, error, required, hint }: {
  id: string;
  value: WarrantyValue;
  onChange: (v: WarrantyValue) => void;
  error?: string;
  required?: boolean;
  hint?: string;
}) {
  const { t } = useTranslation();
  return (
    <Field id={id} label={t('warranty.label')} hint={hint ?? t('warranty.hint')} error={error} required={required}>
      {(control) => (
      <div className="flex flex-wrap items-center gap-3">
        <input
          {...control}
          type="date"
          className="input w-44"
          value={value.none ? '' : value.until}
          disabled={value.none}
          onChange={(e) => onChange({ until: e.target.value, none: false })}
        />
        <label className="inline-flex min-h-touch cursor-pointer items-center gap-2 text-sm">
          <input
            type="checkbox"
            className="h-4 w-4 accent-primary-700"
            checked={value.none}
            onChange={(e) => onChange({ until: '', none: e.target.checked })}
          />
          {t('warranty.none')}
        </label>
      </div>
      )}
    </Field>
  );
}
